export default "__VITE_ASSET__5w0x6mpg__"